import { render, staticRenderFns } from "./ReminderCountdownV2026.vue?vue&type=template&id=021c8328&scoped=true"
import script from "./ReminderCountdownV2026.vue?vue&type=script&lang=js"
export * from "./ReminderCountdownV2026.vue?vue&type=script&lang=js"
import style0 from "./ReminderCountdownV2026.vue?vue&type=style&index=0&id=021c8328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021c8328",
  null
  
)

export default component.exports